function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useRef } from 'react';
// eslint-disable-next-line
import isChromatic from 'chromatic/isChromatic';
import { motion, useInView } from 'framer-motion';
import { slowSpring } from '../../motion/transitions';
var chromatic = isChromatic();
export default function EntryAnimation(param) {
    var view = param.view, delay = param.delay, children = param.children, style = param.style, className = param.className;
    var self = useRef(null);
    var inView = useInView(view !== null && view !== void 0 ? view : self, {
        amount: 'some',
        once: true
    });
    return /*#__PURE__*/ React.createElement(motion.div, {
        ref: self,
        initial: "hidden",
        animate: inView || chromatic ? 'visible' : 'hidden',
        variants: {
            hidden: {
                opacity: 0,
                y: 'calc(max(2rem,50%))'
            },
            visible: {
                opacity: 1,
                y: '0rem'
            }
        },
        transition: _object_spread_props(_object_spread({}, slowSpring), {
            delay: chromatic ? 0 : delay
        }),
        style: style,
        className: className
    }, children);
}

//# sourceMappingURL=EntryAnimation.js.map